<template>
  <div
    v-tooltip="{
      content: tooltipContent,
      offset: 0,
    }"
    class="feature-update-tooltip-wrapper"
  />
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    slideType: {
      type: String,
      default: '',
    },
  },
  computed: {
    tooltipContent() {
      return `
        <div class="py-1.5">
          ${this.title + this.content}
        </div>
      `
    },
  },
}
</script>

<style lang="scss" scoped>
.feature-update-tooltip-wrapper {
  @apply w-full h-full absolute z-1;
}
</style>
